import PropTypes from "prop-types";
import React from "react";
import { SVGIcon2 } from "../common/SVGIconV2";
import classNames from "classnames";

const OddsPCHeaderItem = ({
  children,
  handleClick,
  itemTermKey,
  show,
  trackingInfo,
  reference
}) => {
  const props = {
    automationId: itemTermKey,
    handleClick,
    iconHref: "gear",
    itemTermKey
  };

  const trackingInfoLocal = trackingInfo
    ? Object.assign({}, trackingInfo, { dataLabel: "odds-pc" })
    : Object.assign({}, trackingInfo, {
        dataCategory: "default",
        dataAction: "click",
        dataLabel: "odds-pc"
      });

  const classes = classNames("gearBtn", "circleIcon", {
    showOddsContent: show
  });

  return (
    <div className="odds-options" ref={reference}>
      <a
        className={classes}
        data-testid={props.automationId}
        onClick={props.handleClick}
        data-category={trackingInfoLocal.dataCategory}
        data-action={trackingInfoLocal.dataAction}
        data-label={trackingInfoLocal.dataLabel}
        data-value=""
      >
        <SVGIcon2 iconName={props.iconHref} />
      </a>
      {children}
    </div>
  );
};

OddsPCHeaderItem.propTypes = {
  automationId: PropTypes.string,
  children: PropTypes.node,
  handleClick: PropTypes.func,
  iconHref: PropTypes.string,
  itemTermKey: PropTypes.string,
  show: PropTypes.bool,
  trackingInfo: PropTypes.object,
  reference: PropTypes.func
};

export default OddsPCHeaderItem;
